module.exports = __webpack_public_path__ + "img/velocity.d92fbb64.png";